/* eslint-disable no-undef */
export const isDevEnv = DEV;

export const REQUEST_BASE_URL = VITE_AXIOS_BASE_URL;

export const MANAGE_SITE_BASE_URL = VITE_MANAGE_SITE_BASE_URL;

export const MANAGE_DOMAIN = VITE_MANAGE_DOMAIN;
